import { Component, input } from '@angular/core';
import { Route } from '../../../../utils/route';
import { TabsComponent } from '../../../../components/tabs/tabs.component';
import { RepEvaluationTabComponent } from './rep-evaluation-tab/rep-evaluation-tab.component';
import { RadarChart } from '../../../../components/radar-chart/radar-chart.component';

@Component({
  selector: 'app-rep-dates-analytics',
  imports: [TabsComponent, RepEvaluationTabComponent],
  templateUrl: './rep-dates-analytics.component.html',
  styleUrl: './rep-dates-analytics.component.scss'
})
export class RepDatesAnalyticsComponent extends Route {
  repData = input.required<{ date: string, data: RadarChart }[]>();
}
